<template>
    <div class="table-responsive">
        <table class="table table-bordered table-data ng-table" :class="{'table-spaced': spacedRows, 'table-hover': hover}">
            <!-- Table columns -->
            <thead>
                <tr>
                    <th @click.prevent="sort(column)" :class="{'sortable': !!column.sortable, 'sort-asc': column.sortable == 'asc', 'sort-desc': column.sortable == 'desc', 'text-center': column.center}" v-for="(column, index) in actualColumns" :key="index" :width="column.width || 'auto'">
                        <div class="ng-table-header">
                            <span class="sort-indicator" v-text="column.name"></span>
                        </div>
                    </th>
                </tr>
                <!-- TODO: Filter bar -->
                <tr v-if="false">
                    <th :colspan="actualColumns.length"><i class="fa fa-caret-down"></i></th>
                </tr>
            </thead>
            <!-- Table is loading -->
            <tbody v-if="loading">
                <tr class="table-loading-row">
                    <td height="260" colspan="10" class="text-center">Loading information... <i class="fa fa-spin fa-spinner"></i></td>
                </tr>
            </tbody>
            <!-- Table is empty -->
            <tbody v-if="!loading && ! actualRows.length">
                <tr class="table-empty-row">
                    <td :colspan="columns.length">
                        <div v-if="!error">There is no data to display.</div>
                        <div v-if="error" class="alert alert-danger" v-text="error"></div>
                    </td>
                </tr>
            </tbody>
            <!-- Table is loaded and has data -->
            <tbody v-if="!loading && actualRows.length">
                <tr v-for="(row, index) in actualRows" :key="index" :class="{'spacer': row.spacer}">
                    <td v-if="!row.spacer" v-for="column in columns" :class="{'text-center': column.center}">
                        <slot :name="'column:' + column.key" v-bind="row">
                            <router-link v-if="column.link" :to="column.link(row)" v-text="row[column.key]"></router-link>
                            <span v-if="!column.link" v-html="row[column.key]"></span>
                        </slot>
                    </td>
                    <td v-if="row.spacer" :colspan="columns.length"></td>
                </tr>
            </tbody>
        </table>
        <data-table-pagination :pagination="pagination" @page-changed="pageChanged" :disabled="loading"></data-table-pagination>
    </div>
</template>

<script>
import Pagination from './Pagination.vue'
import {each} from 'lodash-es'

export default {
    props: {
        hover: false,
        spacedRows: false,
        endpoint: null,
        rows: {
            default() {
                return []
            }
        },
        columns: {
            default() {
                return []
            }
        }
    },
    data: () => ({
        loading: false,
        actualRows: [],
        actualColumns: [],
        pagination: {},
        sorted: {},
        page: 1,
        error: ''
    }),
    computed: {
        sorting: function() {
            return this.columns.filter(function(col) {
                return col.sortable == 'asc' || col.sortable == 'desc'
            }).reduce(function(acc, cur, i) {
              acc[cur.key] = cur.sortable
              return acc
            }, {})
        }
    },
    mounted() {
        this.$on('reload', () => this.fetch(this.page))
        this.actualRows = this.spacedRows ? this.spaceRows(this.rows) : this.rows
        this.actualColumns = this.columns.map((col) => {
            col.sortable = col.sortable === true ? col.key : col.sortable
            col.sortable = col.sortable || false
            return col
        })

        if ( this.endpoint ) {
            this.fetch(this.page)
        }
    },
    methods: {
        spaceRows(rows) {
            let spacedRows = []

            each(rows, (row) => {
                spacedRows.push(row)
                spacedRows.push({spacer: true})
            })

            spacedRows.splice(-1, 1)

            return spacedRows
        },
        pageChanged({page}) {
            this.fetch(page)
        },
        fetch(page) {
            this.loading = true
            this.$http.get(this.endpoint, {params: {page, sorting: this.sorting}}).then((response) => {
                this.actualRows = this.spacedRows ? this.spaceRows(response.data.items) : response.data.items
                this.pagination = response.data.meta
                this.loading = false
            }, ({response}) => {
                this.error = "There was an error loading the data."
                this.loading = false
            })
        },
        sort(column) {
            if ( ! column.sortable ) {
                return
            }
            switch(column.sortable) {
                case 'asc':
                    column.sortable = 'desc'
                    break
                case 'desc':
                    column.sortable = true
                    break
                default:
                    column.sortable = 'asc'
                    break
            }

            this.fetch()
        }
    },
    components: {
        'data-table-pagination': Pagination
    }
}
</script>
